import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorPopup from './side/ErrorPopup';
import { SERVER_URL } from '../../config/config';
import '../css/Signup.css';
import logoImage from '../css/img/Main_Logo.png';
import loginIcon from '../css/img/login-icon.png';
import passwordIcon from '../css/img/password-icon.png';
import birthIcon from '../css/img/birth-icon.png';

function Signup() {
  const navigate = useNavigate();
  const passwordCheckRef = useRef(null);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    name: '',
    birth: ''
  });
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  // 비밀번호 확인을 위한 상태 추가
  const [passwordCheck, setPasswordCheck] = useState(''); 
  const [passwordMatch, setPasswordMatch] = useState(null); // true, false, or null
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // {server_url} 제거해봄
      if(passwordMatch !== true) {
        setErrorMessage('비밀번호를 다시 확인하세요.');
        setShowErrorPopup(true);
        passwordCheckRef.current.focus();
        return; 
      }
      const response = await fetch(`${SERVER_URL}/admin/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.result_code === 409) {
        setErrorMessage('아이디 중복입니다.');
        setShowErrorPopup(true);
      } else if (data.result_code === 201) {
        navigate('/signup-success');
      } else {
        setErrorMessage('회원가입 중 오류가 발생했습니다.');
        setShowErrorPopup(true);
      }
    } catch (err) {
      setErrorMessage('서버와의 통신 중 오류가 발생했습니다.');
      setShowErrorPopup(true);
    }
  };

  const handleCancel = () => {
    navigate('/login');
  };


  return (
    <div className="signup-background">
      <div className="signup-center-wrapper">
        <div className="signup-content">
          <h1 className="signup-title">Sign Up</h1>
          <form className="signup-form" onSubmit={handleSubmit}>
            <div className="signup-form-group input-with-icon">
              <img src={loginIcon} alt="아이디" className="input-inside-icon" />
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="아이디"
                required
              />
            </div>

            <div className="signup-form-group input-with-icon">
              <img src={passwordIcon} alt="비밀번호" className="input-inside-icon" />
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="비밀번호"
                required
              />
            </div>

            <div className="signup-form-group input-with-icon">
              <img src={passwordIcon} alt="비밀번호 확인" className="input-inside-icon" />
              <input
                ref={passwordCheckRef}
                type="password"
                id="password_check"
                name="password_check"
                value={passwordCheck}
                onChange={(e) => {
                  const value = e.target.value;
                  setPasswordCheck(value);
                  setPasswordMatch(formData.password === value);
                }}
                placeholder="비밀번호 확인"
                required
              />
            </div>

            <div id="check_message" style={{ display: passwordCheck ? 'block' : 'none' }}>
              <p id="check_message_text" style={{ color: passwordMatch ? 'green' : 'red' }}>
                {passwordMatch ? '비밀번호가 일치합니다.' : '비밀번호가 일치하지 않습니다.'}
              </p>
            </div>

            <div className="signup-form-group input-with-icon">
              <img src={loginIcon} alt="이름" className="input-inside-icon" />
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="이름"
                required
              />
            </div>

            <div className="signup-form-group input-with-icon">
              <img src={birthIcon} alt="생년월일" className="input-inside-icon" />
              <input
                type="date"
                id="birth"
                name="birth"
                value={formData.birth}
                onChange={handleChange}
                required
                autoComplete="off"
              />
              {!formData.birth && (
                <span className="date-placeholder">생년월일</span>
              )}
            </div>

            <div className="signup-button-group">
              <button type="submit" className="signup-submit-button">
                가입하기  
              </button>
              <button type="button" className="signup-cancel-button" onClick={handleCancel}>
                취소
              </button>
            </div>
          </form>
        </div>
      </div>
      {showErrorPopup && (
        <ErrorPopup
          message={errorMessage}
          onClose={() => setShowErrorPopup(false)}
        />
      )}
    </div>
  );
}

export default Signup; 